import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import HeaderCell from "./HeaderCell"

const FixedTableHeaderStyles = {
  position: "fixed",
  top: "48px",
  zIndex: 3,
  "overflow-x": "scroll",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "-ms-overflow-style": "none",
  "scrollbar-width": "none",
  transition: "opacity 60ms linear",
}

const TableHeader = styled.div([], (props) => ({
  ...(props.isFixed && FixedTableHeaderStyles),
  width: `${props.width}px`,
  visibility: `${props.isVisible ? "visible" : "hidden"}`, // Set fixed header to hidden so it's not clickable while not visible
  opacity: `${props.isVisible ? "1" : "0"}`, // Handle visibility with opacity so it can be animated
}))

const Header = React.forwardRef(({ headerGroups, isFixed, isVisible, width, onScroll }, ref) => {
  //forward the ref so we can manipulate the scroller
  return (
    <TableHeader
      isFixed={isFixed}
      isVisible={isVisible}
      width={width}
      ref={ref}
      onScroll={onScroll}
      id="sticky-article-table-header"
    >
      {headerGroups.map((headerGroup, i) => (
        //headerGroups is needed for the header props to display correctly
        <div key={i} {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column, i) => {
            return (
              <HeaderCell
                key={column.id}
                column={column}
                isArticleCodeCell={i === 0}
                isSortable={!column.disableSortBy}
                isSingleAttribute={headerGroup.headers.length === 1}
              />
            )
          })}
        </div>
      ))}
    </TableHeader>
  )
})

Header.displayName = "Header"

export default Header

Header.propTypes = {
  headerGroups: PropTypes.array,
  isFixed: PropTypes.bool,
  isVisible: PropTypes.bool,
  width: PropTypes.number,
  onScroll: PropTypes.func,
}
